export const cookies = function () {
	//Cookies
    if(localStorage.getItem('stickerboutique_cookie')){
        $('#cookie-sticker').addClass('hide');
    }else{
        $('#cookie-sticker').delay(900).addClass('show');
        $('#ok-cookie').click(() => {
            localStorage.setItem('stickerboutique_cookie', 'true');
            $('#cookie-sticker').addClass('hide');
            console.log('Acepto cookies')
        })
    }

}



// WEBPACK FOOTER //
// ./resources/assets/js/cookies.js